import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { ApiGroup as ApiGroupType } from '@/types/api';
import { ApiCard } from './ApiCard';

interface ApiGroupProps {
  group: ApiGroupType;
  defaultExpanded?: boolean;
}

/**
 * Component for displaying a group of APIs organized by type
 */
export const ApiGroup: React.FC<ApiGroupProps> = ({ 
  group, 
  defaultExpanded = false
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  // Since we now use type directly for grouping, no sub-categorization needed

  return (
    <div className="border border-gray-200 rounded-lg">
      <div
        className="flex items-center justify-between p-4 bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center space-x-3">
          {isExpanded ? (
            <ChevronDown className="w-4 h-4 text-gray-600" />
          ) : (
            <ChevronRight className="w-4 h-4 text-gray-600" />
          )}
          <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
          <div>
            <h3 className="text-base font-semibold text-gray-900">
              {group.displayName || group.type}
            </h3>
            {group.description && (
              <p className="text-sm text-gray-600 mt-1">{group.description}</p>
            )}
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded text-sm font-medium">
            {group.apis.length}
          </span>
        </div>
      </div>

      {isExpanded && (
        <div className="border-t border-gray-200">
          <div className="divide-y divide-gray-200">
            {group.apis.map((api) => (
              <ApiCard key={api.id} api={api} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
